import { helpers } from '@reporting/rp-app-host';

const CLIENT_URL = process.env.CLIENT_URL || helpers.url(window.location.href, {path: false, query: false});
const CLIENT_AUTH_URL = process.env.CLIENT_AUTH_URL || helpers.url(window.location.href, {path: false, query: false});
const GATEWAY_URL = process.env.GATEWAY_URL || (CLIENT_URL + '/ms');
const EXPORT_URL = process.env.EXPORT_URL || null;
const STATIC_URL = process.env.STATIC_URL || helpers.url(window.location.href, {path: false, query: false});
const PACKAGE_NAME = process.env.PACKAGE_NAME;
const PACKAGE_VERSION = process.env.PACKAGE_VERSION;
const PACKAGE_VERSION_HASH = process.env.PACKAGE_VERSION_HASH;
const ACCESS_TOKEN_REFRESH_THRESHOLD = 120; // seconds

const constants = {
	CLIENT_URL,
	CLIENT_AUTH_URL, 
	GATEWAY_URL,
	EXPORT_URL,
	STATIC_URL,
	PACKAGE_NAME,
	PACKAGE_VERSION,
	PACKAGE_VERSION_HASH,
	ACCESS_TOKEN_REFRESH_THRESHOLD
};

export default constants;
